var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFridge = function SvgFridge(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M97.941 8.977h167.74c13.05 0 23.586 10.65 23.586 23.575v101.36H74.357V32.552c0-12.924 10.656-23.575 23.586-23.575zm12.092 45.354c5.627 0 10.297 4.667 10.297 10.291v39.969c0 5.744-4.67 10.411-10.297 10.411-5.747 0-10.416-4.667-10.416-10.411V64.622c0-5.624 4.67-10.291 10.416-10.291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1227",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M124.52 348.98h19.156c1.556 0 2.754-1.316 2.754-2.752V334.62h-24.544v11.608c0 1.436 1.197 2.752 2.634 2.752z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M223.77 348.98h19.156c1.437 0 2.754-1.316 2.754-2.752V334.62h-24.664v11.608c0 1.436 1.317 2.752 2.754 2.752z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1231",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M110.03 164.31c5.627 0 10.297 4.667 10.297 10.291v75.63c0 5.744-4.67 10.411-10.297 10.411-5.747 0-10.416-4.667-10.416-10.411v-75.63c0-5.624 4.67-10.291 10.416-10.291m-35.679-21.78h214.91v150.54c0 19.267-15.684 34.943-34.96 34.943h-144.99c-19.276 0-34.96-15.677-34.96-34.943z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFridge);
export default ForwardRef;